<template>
  <div class="app_container">
    <div class="filter_container">
      <butn
        btntype="primary"
        title="批量下载"
        @click.native="handleBatchDownload"
        :disabled="checked.length == 0"
      ></butn>
      <!--搜索-->
      <div class="search_right" style="padding-bottom: 6px;">
        <Search @search="searchHandle" />
      </div>
    </div>
    <div class="static_wrap">
      <div class="list">
        <div class="list_item" v-for="(item,i) in staticList" :key="i">
          <span v-if="i == 0 || Number(item.num) < 1" class="font_24">{{item.num}}</span>
          <span v-else class="font_24 text_link" @click="showUserListModal(i, 0)">{{item.num}}</span>
          <span class="m-t-24">{{item.name}}</span>
        </div>
        <div class="today_rect" v-if="Number(param.classStatus) == 3">
          <div class="font_22">今日考勤（应到人数 {{staticInfo.shouldNum}}）</div>
          <div class="m-t-24"><span class="text_bold">上午：</span>在校{{staticInfo.amNum || 0}}人，请假
            <span v-if="!staticInfo.amLeaveNum || Number(staticInfo.amLeaveNum) < 1">&nbsp;0&nbsp;</span>
            <span v-else class="text_blue" @click="showUserListModal(1, 1)">&nbsp;{{staticInfo.amLeaveNum || 0}}&nbsp;</span>人
          </div>
          <div class="m-t-8"><span class="text_bold">下午：</span>在校{{staticInfo.pmNum || 0}}人，请假
            <span v-if="!staticInfo.pmLeaveNum || Number(staticInfo.pmLeaveNum) < 1">&nbsp;0&nbsp;</span>
            <span v-else class="text_blue" @click="showUserListModal(1, 2)">&nbsp;{{staticInfo.pmLeaveNum || 0}}&nbsp;</span>人
          </div>
        </div>
      </div>
    </div>
    <!--表格内容栏-->
    <Tables
      @selection-change="selectChange"
      row-key="uuid"
      :data="attendanceInfo"
    />
    <!--分页栏-->
    <div class="RCPagination">
      <el-button
        icon="el-icon-arrow-left"
        @click="goBack"
        size="small"
        type="primary"
        >返回</el-button
      >
      <RCPagination
        ref="pagination"
        v-model="attendanceInfo"
        :api="api"
        :startRequest="false"
      />
    </div>
    <UserListModal
      :showUserList="showUserList"
      @close="closeUserListModal"
      :leaveType="leaveType"
      :scopeType="scopeType"
      v-if="showUserList.flag"
    />
  </div>
</template>
<script>
import RCPagination from "@/components/pagination/paginationManage";
import Tables from "./table.js";
import Search from "./search";
import butn from "@/components/button/index";
import {attendanceInfo,exportAttendanceInfo, attendanceStatistics} from "@/api/rainingManage";
import UserListModal from "./userListModal/index.vue"
export default {
  name: "attendanceManageAttendance",
  components: {
    Tables,
    Search,
    RCPagination,
    butn,
    UserListModal
  },
  data() {
    return {
      size: "small",
      attendanceInfo: [], //列表的集合
      api: attendanceInfo, // 请求路径对应api下的方法名
      param: {
        classId: "",
        classChildId: ""
      },
      filterkeys: "",
      checked: [],
      staticList: [{ num: 0, name: "总人数"}, { num: 0, name: "请假人数"}, { num: 0, name: "退学人数"}],
      staticInfo: {},
      showUserList: {
        flag: false
      },
      leaveType: 1, // 1:请假，2:退学
      scopeType: 0, // 查询范围 0全部、1上午、2下午
    };
  },
  methods: {
    // 显示人员名单
    showUserListModal(leaveType, scopeType) {
      this.leaveType = leaveType;
      this.scopeType = scopeType;
      this.showUserList.flag = true;
    },
    // 关闭人员名单
    closeUserListModal() {
      this.leaveType = 1;
      this.scopeType = 0;
      this.showUserList.flag = false;
    },
    getAttendanceStatistics() {
      attendanceStatistics({ classId: this.param.classId, classChildId: this.param.classChildId }).then((res) => {
        if (!res || res.code != 0) return;
        this.staticList[0].num = res.data.totalNum;
        this.staticList[1].num = res.data.leaveNum;
        this.staticList[2].num = res.data.dropOutNum;
        this.staticInfo = res.data;
      })
    },
    goBack() {
      if (this.$route.query.childId) {     
        this.$router.push({
          path: "/attendanceManage/smallClassData",
          query: { classId: this.$route.query.classId }});
      } else {
        this.$router.push('/attendanceManage');
      }
    },
    searchHandle(param) {
      //搜索
      param.classId = this.$route.query.classId;
      param.courseName = param.courseName;
      if (this.$route.query.childId) {
        param.classChildId = this.$route.query.childId;
      }
      this.filterkeys = param;
      this.$refs["pagination"].reload(param);
    },
    selectChange(selections) {
      this.checked = selections
    },
    //批量下载  1：打包压缩下载  0直接下载
    handleBatchDownload() {
      let param = {};
      param = this.checked;
      this.handleDownload(param);
    },
    handleDownload(param) {
      exportAttendanceInfo(param).then(response => {
        let data = response.data;
        let fileReader = new FileReader();
        let _this = this;
        fileReader.onload = function() {
          try {
            let jsonData = JSON.parse(this.result);
            if (jsonData.code) {
              _this.$message({
                message: jsonData.msg,
                type: "error"
              });
            }
          } catch (e) {
            let blob = new Blob([response.data]); //创建一个blob对象
            const uA = window.navigator.userAgent;
            const isIE =
              /msie\s|trident\/|edge\//i.test(uA) &&
              !!(
                "uniqueID" in document ||
                "documentMode" in document ||
                "ActiveXObject" in window ||
                "MSInputMethodContext" in window
              );
            let a = document.createElement("a"); //创建一个<a></a>标签
            let href = window.URL.createObjectURL(blob); // response is a blob
            a.href = href;
            let title = decodeURI(escape(response.headers.downloadname)); //文件名称
            a.download = title;
            a.style.display = "none";
            document.body.appendChild(a);
            if (isIE) {
              // 兼容IE11无法触发下载的问题
              navigator.msSaveBlob(blob, title);
            } else {
              a.click();
            }
            document.body.removeChild(a); // 下载完成移除元素
            // window.URL.revokeObjectURL(href); // 释放url
          }
        };
        fileReader.readAsText(data);
        // 更新列表
        this.$refs["pagination"].search(this.param);
      });
    }
  },
  created() {
    this.param.classId = this.$route.query.classId;
    this.param.classChildId = this.$route.query.childId;
    this.param.classStatus = this.$route.query.classStatus;
    this.getAttendanceStatistics();
    this.$nextTick(() => {
      this.searchHandle({});
    });
  }
};
</script>

<style lang="scss" scoped>
.RCPagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.font_24 {
  font-size: 24px !important;
  font-weight: bold;
}
.font_22 {
  font-size: 22px !important;
  font-weight: bold;
}
.text_bold {
  font-weight: bold;
}
.text_link {
  color: #2640AC;
  cursor: pointer;
}
.text_blue {
  color: #3A85FF;
  cursor: pointer;
}
.m-t-24{
  margin-top: 24px;
}
.m-t-8 {
  margin-top: 8px;
}
.static_wrap {
  margin-bottom: 40px;
  .list {
    display: flex;
    .list_item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 18%;
      height: 140px;
      background: rgba(246, 247, 255, 1);
      margin-right: 40px;
      font-size: 18px;
      border-radius: 4px;
    }
    .today_rect {
      padding: 24px 0 24px 20px;
      width: 39%;
      height: 92px;
      background: rgba(246, 247, 255, 1);
      border-radius: 4px;
      font-size: 16px;
    }
  }
}
</style>
